import {
  PAYROLL_REPORTS_HEADER,
  PAYROLL_REPORTS_HEADER_SUCCESS,
  PAYROLL_REPORTS_HEADER_FAIL,
  RESET_REPORTS,RESET_REPORTS_SUCCESS,RESET_REPORTS_FAILURE
} from "./actionTypes";

export const payrollReportsHeader = (parameters) => {
  return {
    type: PAYROLL_REPORTS_HEADER,
    payload: parameters,
  };
};

export const payrollReportsHeaderSuccess = (results) => {
  return {
    type: PAYROLL_REPORTS_HEADER_SUCCESS,
    payload: results,
  };
};

export const payrollReportsHeaderFail = (error) => {
  return {
    type: PAYROLL_REPORTS_HEADER_FAIL,
    payload: error,
  };
};
export const resetreportpayroll=(parameters)=>{
  return{
    type:RESET_REPORTS,
    payload:parameters

  }
}
export const resetreportpayrollSuccess=(result)=>{
  return{
    type:RESET_REPORTS_SUCCESS,
    payload:result

  }
}
export const resetreportpayrollFailure=(error)=>{
  return{
    type:RESET_REPORTS_FAILURE,
    payload:error

  }
}
